import type { ApiOrgId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { OrgDashboardApiCreditPackForPurchase } from './types/OrgDashboardApiCreditPackForPurchase';

type ApiResponse = {
  forPurchase: OrgDashboardApiCreditPackForPurchase[];
};

function mapResponse(data: ApiResponse) {
  return data.forPurchase;
}

const endpoint = new FetchEndpoint({
  urlFactory: (orgId: ApiOrgId) =>
    `/data/orgdashboard/${orgId}/credits-for-purchase`,
  mapResponse,
});

// Exports

export const orgDashboardApiIsomorphicFetchCreditsForPurchase =
  endpoint.createIsomorphicFetchFn();
